<template>
  <div id="data-list-list-view" class="data-list-container">

    <vx-card v-if="filter && !idInscription" ref="filterCard" :title="$t('Filter')" class="user-list-filters mb-4" actionButtons @refresh="initInput" @remove="resetColFilters">
      <div class="vx-row">
        <div class="vx-col lg:w-1/4 md:w-1/2 sm:w-1/2 w-full">
          <p class="mb-2">{{ $t("level") }}</p>
          <v-select :options="niveaus" 
          :reduce="rep => rep.id" :clearable="true" label="libelle" v-model="niveauSaisie" class="w-full"/>                
        </div>
        <div class="vx-col lg:w-1/4 md:w-1/2 sm:w-1/2 w-full">
          <p class="mb-2" >{{ $t("class") }} </p>
          <v-select :options="classes"
          :disabled="niveauSaisie? false : true" @search="getClasse" :clearable="true" label="libelle" v-model="classeSaisie" class="w-full"/>
        </div>
        <div class="vx-col lg:w-1/4 md:w-1/2 sm:w-1/2 w-full">
          <p class="mb-2" >{{ $t("room") }} </p>
          <v-select :options="salles"
          :disabled="classeSaisie? false : true" :clearable="true" label="libelle" v-model="salleSaisie" class="w-full"/>
        </div>
        <div class="vx-col lg:w-1/4 md:w-1/2 sm:w-1/2 w-full">
          <p class="mb-2" >{{ $t("type_of_fees") }} </p>
          <v-select 
            :options="typeFraiss"
            :clearable="true" 
            label="libelle" 
            v-model="typeFraisSaisie" 
            class="w-full"
          />
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col lg:w-1/3 md:w-1/3 sm:w-1/3 w-full">
          <p class="mt-4" > Élève </p>
          <v-select
            :options="inscriptions"
            @search="getInscription"
            :clearable="true"
            :reduce="rep => rep.id" 
            :getOptionLabel="getOptionLabel"
            v-model="inscriptionEleveSelectionner"
            class="w-full"
          />
        </div>
        <div class="vx-col lg:w-1/3 md:w-1/3 sm:w-1/3 w-full">
          <p class="mt-4" > {{ $t('Start_date') }} </p>
            <datepicker v-model="dateDebutSaisie" name="dateDebut"></datepicker>
        </div>
        <div class="vx-col lg:w-1/3 md:w-1/3 sm:w-1/3 w-full">
          <p class="mt-4" > {{ $t('End_date') }} </p>
            <datepicker v-model="dateFinSaisie" :clearable="true" name="dateDebut"></datepicker>
        </div>
      </div>
    </vx-card>

    <vx-card ref="filterCard55" class="user-list-filters mb-4">
      <div class="vx-row flex flex-wrap-reverse items-center flex-grow justify-between">
        <div class="vx-col lg:w-1/3 md:w-1/3 sm:w-full w-full">
          <ul class="demo-alignment">
              <li>
                  <vs-radio v-model="annuler" :vs-value="false" color="danger" > Non annulé </vs-radio>
              </li>
              <li>
                  <vs-radio color="success" v-model="annuler" :vs-value="true"> Annulé </vs-radio>
              </li>
          </ul>
        </div>
        <div class="vx-col lg:w-1/3 md:w-1/3 sm:w-full w-full">
          <ul class="demo-alignment">
              <li>
                  <vs-radio v-model="annulationAutomatique" :vs-value="false" color="danger" > Non annulé automatiquement </vs-radio>
              </li>
              <li>
                  <vs-radio color="success" v-model="annulationAutomatique" :vs-value="true"> Annulé automatiquement </vs-radio>
              </li>
          </ul>
        </div>
        <div class="vx-col lg:w-1/3 md:w-1/3 sm:w-full w-full">
          <ul class="demo-alignment">
              <li>
                  <vs-radio v-model="creationAutomatique" :vs-value="false" color="danger" > Non créer automatiquement </vs-radio>
              </li>
              <li>
                  <vs-radio color="success" v-model="creationAutomatique" :vs-value="true"> Créer automatiquement </vs-radio>
              </li>
          </ul>
        </div>
      </div>
    </vx-card>

    <vs-table :noDataText="$t('No_data_Available')" ref="table" :data="recus">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <div class="flex flex-wrap-reverse items-center data-list-btn-container">
          <div
            class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"
            @click="getPdfOfAllReiceive"
          >
            <feather-icon icon="FileIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary"> Imprimer </span>
          </div>

          <vx-tooltip :text="$t('Filterlist')" color="warning">
            <div
              v-if="!idInscription"
              class="btn-add-new p-4 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-warning border border-solid border-warning"
              @click="filter=!filter"
            >
              <feather-icon icon="FilterIcon" svgClasses="h-4 w-4" />
            </div>
          </vx-tooltip>
        </div>

        <vs-chip class="ag-grid-cell-chip" color="primary" style="font-size: 16px; font-weight: 800">
          <span>Total -:-  {{ new Intl.NumberFormat('de-DE').format(sommeTotalRecu ? sommeTotalRecu : '0') }} Francs CFA </span>
        </vs-chip>
        
        <div class="flex flex-wrap">
          <!-- ITEMS PER PAGE -->
          <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
            <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">{{ param.paginate.page * param.paginate.length - (param.paginate.length - 1) }} - {{ taille - param.paginate.page * param.paginate.length > 0 ? param.paginate.page * param.paginate.length : taille }} {{ $t("of_sur") }} {{ taille }}</span>
              <feather-icon icon="ChevronDownIcon" svgInscriptions="h-4 w-4" />
            </div>

            <vs-dropdown-menu>
              <vs-dropdown-item :key="indexItem" v-for="(item, indexItem) in itemsPerPages" @click="param.paginate.length=item, getRecus()">
                <span> {{item}} </span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>

          <vs-input icon-pack="feather" icon="icon-search" :placeholder="$t('Search')" v-model="search" class="is-label-placeholder mb-8" />
        </div>
      </div>

      <template slot="thead">
        <vs-th sort-key="inscription.eleve.matricule">
          Recu N°
        </vs-th>
        <vs-th sort-key="inscription.eleve.full_name">{{ $t("full_name") }}</vs-th>
        <vs-th > Classe </vs-th>
        <vs-th >{{ $t("type_of_fees") }}</vs-th>
        <vs-th > Annulé ? </vs-th>
        <vs-th >{{ $t("Payed") }}</vs-th>
        <vs-th >{{ $t("Date") }}</vs-th>
        <vs-th >{{ $t("Actions") }}</vs-th>
      </template>
        <template slot-scope="{data}">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>
                <p class="product-name font-medium truncate">{{ tr.id }}</p>
              </vs-td>

              <vs-td>
                <p class="product-name font-medium truncate">{{ tr.inscription.eleve.full_name }}</p>
              </vs-td>

              <vs-td>
                <p class="product-name font-medium truncate">{{ tr.frais.classe.libelle }}</p> 
              </vs-td>

              <vs-td>
                <vs-chip class="ag-grid-cell-chip" :color="afficheCouleur(tr.frais.typeFrais.id)">
                  <span>{{ tr.frais.typeFrais.libelle }}</span>
                </vs-chip>
              </vs-td>

              <vs-td>
                <vs-chip class="ag-grid-cell-chip" :color="tr.annuler ? 'success' : 'danger'">
                  <span>{{ tr.annuler ? 'OUI' : 'NON' }}</span>
                </vs-chip>
              </vs-td>

              <vs-td style="text-align: right;">
                <p class="product-name font-medium truncate">
                  {{ new Intl.NumberFormat('de-DE').format(tr.montant) }}
                </p>
              </vs-td>

              <vs-td>
                <p class="product-name font-medium truncate">{{ $store.state.convertDateTime(new Date(tr.dateDePaiement)).date }}</p>
              </vs-td>

              <vs-td class="whitespace-no-wrap">
                <div class="flex">

                  <vx-tooltip text="Régulariser" color="primary">
                    <feather-icon
                      v-if="frais && frais !== tr.frais.id"
                      @click="regulariser(tr, frais)"
                      style="color: #ff7b00"
                      icon="RefreshCwIcon"
                      svgClasses="w-5 h-5 hover:text-primary stroke-current"
                      class="mr-2"
                    />
                  </vx-tooltip>
                  
                  <vx-tooltip text="Imprimer le reçu" color="success">
                    <feather-icon
                      @click="imprimerRecu(tr)"
                      style="color: green"
                      icon="FileIcon"
                      svgClasses="w-5 h-5 hover:text-success stroke-current"
                      class="mr-2"
                    />
                  </vx-tooltip>

                <vx-tooltip
                  :text="$t('Delete')"
                  color="danger"
                  v-if="!tr.annuler"
                >
                  <feather-icon
                    v-if="!tr.annuler"
                    @click="annulerRecu(tr.id)"
                    style="color: red;"
                    icon="XCircleIcon"
                    svgClasses="w-5 h-5 hover:text-danger stroke-current"
                    class="mr-2"
                  />
                </vx-tooltip>
                </div>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
    </vs-table>
    <div class="items-center">
      <vs-pagination :total="total" v-model="currentPage"></vs-pagination>
    </div>

  </div>
</template>

<script>
let base_self = ''
import Datepicker from 'vuejs-datepicker'

// Inscription
const input_tempon = {
  salle: '',
  classe: '',
  typeFrais: '',
  tranche: '',
  dateDebut: '',
  dateFin: ''
}
const colors = ['success', 'danger', 'warning', 'primary', 'dark']
let colorIndex = 0

export default {
  components: {
    Datepicker
  },
  props: {
    idInscription: {
      type: Number,
      default: () => { return 0 },
      required: false
    },
    idTypeFrais: {
      type: Number,
      default: () => { return 0 },
      required: false
    },
    frais: {
      type: Number,
      default: () => { return 0 },
      required: false
    }
  },
  data () {
    return {
      inscriptionEleveSelectionner: '',
      paramInscription: {
        is_get: true,
        paginate: {
          length: 10,
          page: 1
        },
        filter: {
          q_list: [],
          abandon: false,
          anneeScolaire__cloture: false,
          anneeScolaire__encours: true
        },
        orderby: ['eleve__full_name'],
        juste: {
          id: '',
          eleve: {
            id: '',
            full_name: ''
          }
        }
      },
      annuler: false,
      creationAutomatique: false,
      annulationAutomatique: false,
      sommeTotalRecu: 0,
      recus: [],
      niveaus: [],
      niveauSaisie: '',
      classeSaisie: '',
      salleSaisie: '',
      typeFraisSaisie: '',
      dateDebutSaisie: '',
      dateFinSaisie: '',
      solded: false,
      inscriptions: [],
      typeFraiss: [],
      objectColor: {},
      salles: [],
      classes: [],
      tranches: [],
      input: JSON.parse(JSON.stringify(input_tempon)),
      input1: JSON.parse(JSON.stringify(input_tempon)),
      filter: true,
      search: '',
      param: {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: {
          inscription__anneeScolaire__encours: true,
          inscription__anneeScolaire__cloture: false,
          annuler: false,
          creationAutomatique: false,
          annulationAutomatique: false
        }/* ,
        juste: {} */
      },
      paramSalle: {},
      paramTypeFrais: {},
      paramTranches: {},
      itemsPerPages: this.$store.state.itemsPerPages,
      taille: 0,
      currentPage: 1,
      selected: [],
      isMounted: false,
      sidebarData: {}
    }
  },
  watch: {
    idInscription () {
      base_self.initialiserTous()
    },
    idTypeFrais () {
      base_self.initialiserTous()
    },
    inscriptionEleveSelectionner (value) {
      if (value) {
        base_self.param.filter['inscription__id'] = value
      } else {
        delete base_self.param.filter['inscription__id']
      }

      base_self.getRecus()
    },
    annuler (value) {
      base_self.param.filter['annuler'] = value

      base_self.getRecus()
    },
    creationAutomatique (value) {
      base_self.param.filter['creationAutomatique'] = value

      base_self.getRecus()
    },
    annulationAutomatique (value) {
      base_self.param.filter['annulationAutomatique'] = value

      base_self.getRecus()
    },
    dateDebutSaisie (value) {
      if (value) {
        const resultat = new Date(base_self.$store.state.convertDateTime(new Date(value)).date)
        console.log(' ++++++++++++++++++++++++++ resultat: ', resultat)
        base_self.param.filter['dateDePaiement__gte'] = resultat
      } else {
        delete base_self.param.filter['dateDePaiement__gte']
      }

      console.log('str ++ ', JSON.stringify(base_self.param))

      base_self.param.paginate.page = 1
      base_self.currentPage = 1
      base_self.getRecus()
    },
    dateFinSaisie (value) {
      const resultat = new Date(`${base_self.$store.state.convertDateTime(new Date(value)).date}T23:59:59.000Z`)
      console.log('value: 2021-09-01T00:00:00.000Z resultat: ', resultat)

      if (resultat) {
        base_self.param.filter['dateDePaiement__lte'] = resultat
      } else {
        delete base_self.param.filter['dateDePaiement__lte']
      }

      base_self.param.paginate.page = 1
      base_self.currentPage = 1
      base_self.getRecus()
    },
    classeSaisie (value) {
      if (value) {
        base_self.salleSaisie = null
        base_self.typeFraisSaisie = null

        base_self.getSalleSimple()

        // getRecus
        base_self.param.filter['inscription__salle__classe__id'] = value.id
      } else {
        base_self.salleSaisie = null
        base_self.typeFraisSaisie = null

        // getRecus
        delete base_self.param.filter['inscription__salle__classe__id']
      }

      base_self.param.paginate.page = 1
      base_self.currentPage = 1
      base_self.getRecus()
    },
    salleSaisie (value) {
      if (value) {
        // getRecus
        base_self.param.filter['inscription__salle__id'] = value.id
      } else {
        // getRecus
        delete base_self.param.filter['inscription__salle__id']
      }

      base_self.param.paginate.page = 1
      base_self.currentPage = 1
      base_self.getRecus()
    },
    typeFraisSaisie (value) {
      if (value) {
        // getRecus
        base_self.param.filter['frais__typeFrais__id'] = value.id
      } else {
        // getRecus
        delete base_self.param.filter['frais__typeFrais__id']
      }

      base_self.param.paginate.page = 1
      base_self.currentPage = 1
      base_self.getRecus()
    },
    niveauSaisie (value) {
      base_self.classeSaisie = null

      if (value) {
        // getRecus
        base_self.getClasseSimple()
        base_self.param.filter['inscription__salle__classe__niveau__id'] = value
      } else {
        // getRecus
        delete base_self.param.filter['inscription__salle__classe__niveau__id']
      }

      base_self.param.paginate.page = 1
      base_self.currentPage = 1
      base_self.getRecus()
    },
    currentPage (value) {
      base_self.param.paginate.page = value
      base_self.getRecus()
    },
    search (value) {
      if (value.length) {
        base_self.param.filter.q_list = [
          // { id: value },
          { inscription__eleve__full_name__icontains: value },
          { inscription__statutEleve__libelle__icontains: value },
          { inscription__eleve__dateEntree__icontains: value },
          { inscription__eleve__naissance__icontains: value },
          { inscription__eleve__sexe__code__icontains: value },
          { inscription__salle__libelle__icontains: value }
        ]
      } else {
        base_self.param.filter.q_list = []
      }
      base_self.getRecus()

      console.log('search: ', value)
    }
  },
  computed: {
    total () {
      return Math.ceil(base_self.taille / base_self.param.paginate.length)
    }
  },
  methods: {
    regulariser (tr, frais) {
      const input = {
        id: tr.id,
        frais,
        annulationAutomatique: false,
        annuler: false
      }

      base_self.$http.put(`${base_self.$store.state.route_for_esm}Recu`, input)
        .then((response) => { 
          window.getESM.success('Le reçu est régularisé avec succès.', response)
          base_self.initialiserTous()
        })
        .catch((error) => { 
          console.log('error: ', error)
        })
    },
    getOptionLabel (option) {
      if (typeof option === 'object') {
        
        return `${option.eleve.full_name}`
      }
      return option
    },
    getInscriptionSimple () {
      delete base_self.paramInscription.filter['eleve__full_name__icontains']
      base_self.$http.post(`${base_self.$store.state.route_for_esm}Inscription`, base_self.paramInscription)
        .then((response) => {
          base_self.inscriptions = JSON.parse(JSON.stringify(response.data.data))

          console.log('base_self.inscriptions: ', base_self.inscriptions)
        })
        .catch((error) => {
          console.log('error: ', error)
        })
    },
    getInscription (search, loading) {
      loading(true)
      base_self.paramInscription.filter['eleve__full_name__icontains'] = search
      base_self.$http.post(`${base_self.$store.state.route_for_esm}Inscription`, base_self.paramInscription)
        .then((response) => {
          base_self.inscriptions = JSON.parse(JSON.stringify(response.data.data))
          loading(false)
        })
        .catch((error) => {
          loading(false)
          console.log('error: ', error)
        })
    },
    async annulerRecu (id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: base_self.$t('Confirmation'),
        text: 'Êtes-vous sûr de vouloir annuler ce reçu ?',
        acceptText: base_self.$t('Confirm'),
        cancelText: 'Cancel',
        accept: async () => {
          // console.log('id: ', id)
          const data = {
            id,
            dateAnnulation: new Date(),
            annuler: true
          }

          console.log('data: ', data)

          base_self.$http
            .put(`${base_self.$store.state.route_for_esm}Recu`, data)
            .then((response) => {
              console.log('response: ', response)
              console.log('response: ', response)
              console.log('response: ', response)
              window.getESM.success(
                'Le reçu est annulé avec succès.',
                response,
              )
            })
            .catch(() => {
              window.getESM.error('L\'annulation du reçu a échoué.')
            })
        }
      })
    },
    imprimerRecu (tr) {
      window.open(`${base_self.$http.defaults.baseURL}${base_self.$store.state.route_for_esm}pdf/imprimer-recu/${tr.id}`, '_blank')
    },
    getPdfOfAllReiceive () {
      // const adeee = ''
      // const adeee1 = ''

      const filter_list = JSON.stringify(base_self.param.filter)
      // window.open(`${base_self.$http.defaults.baseURL}${base_self.$store.state.route_for_esm}pdf/liste_recu_trier/${adeee}/${adeee1}`, '_blank')
      window.open(`${base_self.$http.defaults.baseURL}${base_self.$store.state.route_for_esm}pdf/liste_recu_trier/${filter_list}`, '_blank')
    },
    seePicture (link) {
      if (!link) return ''

      link = link.substring(1)
      return `${base_self.$http.defaults.baseURL}${base_self.$store.state.route_for_esm}${link}`
    },
    getNiveauSimple () {
      const data = {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: { is_active: true }
      }
      base_self.$http.post(`${base_self.$store.state.route_for_esm}Niveau`, data)
        .then((response) => {
          base_self.niveaus = response.data.data
        })
        .catch((error) => { 
          console.log('error: ', error)
        })
    },
    afficheCouleur (id) {
      if (base_self.objectColor[id]) {
        return base_self.objectColor[id]
      }

      base_self.objectColor[id] = colors[colorIndex]
      colorIndex++
      if (colorIndex === 5) {
        colorIndex = 0
      }

      return base_self.objectColor[id]
    },
    initInput () {
      base_self.input = JSON.parse(JSON.stringify(input_tempon))
      base_self.$refs.filterCard.removeRefreshAnimation()
    },
    getSalleSimple () {
      if (base_self.classeSaisie && base_self.classeSaisie.id) {
        const data = {
          is_get: true,
          paginate: {
            length: 50,
            page: 1
          },
          filter: { is_active: true, classe__id: base_self.classeSaisie.id, classe__is_active: true, classe__niveau__is_active: true },
          exclude: { code: 'Attente' }
        }

        base_self.$http.post(`${base_self.$store.state.route_for_esm}Salle`, data)
          .then((response) => {
            base_self.salles = response.data.data

            if (base_self.salles.length === 1) {
              base_self.salleSaisie = base_self.salles[0]
            }
          })
          .catch((error) => {
            console.log('error: ', error)
          })
      }
    },
    getClasseSimple () {

      const data = {
        is_get: true,
        paginate: {
          length: 150,
          page: 1
        },
        filter: { is_active: true, niveau__id: base_self.niveauSaisie, niveau__is_active: true },
        juste: {
          id: '',
          libelle: ''
        }
      }

      base_self.$http.post(`${base_self.$store.state.route_for_esm}Classe`, data)
        .then((response) => {
          base_self.classes = response.data.data
        })
        .catch((error) => {
          console.log('error: ', error)
        })
    },
    getClasse (search, loading) {
      loading(true)
      const data = {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: { is_active: true, niveau__id: base_self.niveauSaisie, niveau__is_active: true, libelle__icontains: search }
      }
      base_self.$http.post(`${base_self.$store.state.route_for_esm}Classe`, data)
        .then((response) => {
          base_self.classes = response.data.data
          loading(false)
        })
        .catch((error) => {
          loading(false)
          console.log('error: ', error)
        })
    },
    getTypeFraissSimple () {
      const data = {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        }
        // filter: { fraiss__is_active: true }
      }

      base_self.$http.post(`${base_self.$store.state.route_for_esm}TypeFrais`, data)
        .then((response) => {
          base_self.typeFraiss = response.data.data

          if (base_self.typeFraiss.length === 1) {
            base_self.typeFraisSaisie = base_self.typeFraiss[0]
          }
        })
        .catch((error) => {
          console.log('error: ', error)
        })
    },
    async getTranches (search, loading) {
      loading(true)
      const data3 = {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: {
          frais__typeFrais__id: base_self.typeFrais.id,
          ordre: search
        },
        orderby: ['ordre']
      }
      const response_3 = await base_self.$http.post(`${base_self.$store.state.route_for_esm}Tranche`, data3)
        .catch((error) => {
          console.log('error: ', error)
        })

      base_self.tranches = JSON.parse(JSON.stringify(response_3.data.data))
    },
    async getTranchesSimple () {
      if (base_self.input.classe && base_self.input.classe.id && base_self.input.typeFrais && base_self.input.typeFrais.id) {
        const data3 = {
          is_get: true,
          paginate: {
            length: 50,
            page: 1
          },
          filter: {
            frais__typeFrais__id: base_self.input.typeFrais.id
          },
          orderby: ['ordre']
        }
        const response_3 = await base_self.$http.post(`${base_self.$store.state.route_for_esm}Tranche`, data3)
          .catch((error) => {
            console.log('error: ', error)
          })
        base_self.tranches = []
        base_self.tranches = response_3.data.data
      }
    },
    resetColFilters () {
      this.$refs.filterCard.removeRefreshAnimation()
    },
    getSommeTotal () {
      base_self.$http.post(`${base_self.$store.state.route_for_esm}somme-total-recu`, base_self.param.filter)
        .then((response) => {
          base_self.sommeTotalRecu = response.data.sommeTotalRecu
          base_self.$vs.loading.close()
        })
        .catch(() => {
          window.getESM.error(base_self.$t('The_server_is_not_responding'))
          base_self.$vs.loading.close()
        })
    },
    async getRecus () {
      base_self.$vs.loading()

      /* console.log('base_self.param: ', base_self.param)
      console.log(' ::::::::::::::::::::::::::::::::::::: base_self.param ::::::::::::::::::::::::::::::::::::: ')
      console.log(' ::::::::::::::::::::::::::::::::::::: base_self.param ::::::::::::::::::::::::::::::::::::: ')
      console.log(' ::::::::::::::::::::::::::::::::::::: base_self.param ::::::::::::::::::::::::::::::::::::: ')
      console.log(' ::::::::::::::::::::::::::::::::::::: base_self.param ::::::::::::::::::::::::::::::::::::: ') */
      
      base_self.$http.post(`${base_self.$store.state.route_for_esm}Recu`, base_self.param)
        .then((response) => {
          base_self.recus = response.data.data
          base_self.taille = response.data.taille
          base_self.$vs.loading.close()

          base_self.sommeTotalRecu = 0
          if (base_self.recus.length) {
            base_self.getSommeTotal()
          }
        })
        .catch(() => {
          window.getESM.error(base_self.$t('The_server_is_not_responding'))
          base_self.$vs.loading.close()
        })
      
    },
    initialiserTous () {
      if (base_self.idTypeFrais) {
        base_self.param.filter['frais__typeFrais__id'] = base_self.idTypeFrais
      }

      if (base_self.idInscription) {
        base_self.param.filter['inscription__id'] = base_self.idInscription
      } else {
        base_self.getInscriptionSimple()
        base_self.getTypeFraissSimple()
        base_self.getNiveauSimple()
      }

      base_self.getRecus()
    }
  },
  created () {
    base_self = this

    base_self.initialiserTous()
  },
  mounted () {
    this.isMounted = true
  }
}
</script>

<style>
.vs-input--input {
  border-radius: 20px;
  padding: 0.9rem 2.5rem;
  font-size: 1rem;
}

</style>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
